module.exports = __webpack_public_path__ + "static/img/videoH.3ef9db9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grid/videoH.png
// module id = WiNd
// module chunks = 3